import { ShareStoreProps } from "./share-store.types";
import { ShareStoreSkin1 } from "./skins/share-store-skin-1";

export const ShareStore = (props: ShareStoreProps) => {
  return <ShareStoreSkin1 {...props} />;
};
